module.exports = __webpack_public_path__ + "./config/rogers-dev.json";